/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EntryDto } from '../models/entry-dto';
import { getPages } from '../fn/journal/get-pages';
import { GetPages$Params } from '../fn/journal/get-pages';
import { insertEntry } from '../fn/journal/insert-entry';
import { InsertEntry$Params } from '../fn/journal/insert-entry';
import { PaginatedBody } from '../models/paginated-body';

@Injectable({ providedIn: 'root' })
export class JournalService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPages()` */
  static readonly GetPagesPath = '/svgs/{svgId}/customers/{customerId}/journal';

  /**
   * Get journal entries (paginated).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPages$Response(params: GetPages$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedBody>> {
    return getPages(this.http, this.rootUrl, params, context);
  }

  /**
   * Get journal entries (paginated).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPages(params: GetPages$Params, context?: HttpContext): Observable<PaginatedBody> {
    return this.getPages$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedBody>): PaginatedBody => r.body)
    );
  }

  /** Path part for operation `insertEntry()` */
  static readonly InsertEntryPath = '/svgs/{svgId}/customers/{customerId}/journal';

  /**
   * Create a journal entry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `insertEntry()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  insertEntry$Response(params: InsertEntry$Params, context?: HttpContext): Observable<StrictHttpResponse<EntryDto>> {
    return insertEntry(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a journal entry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `insertEntry$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  insertEntry(params: InsertEntry$Params, context?: HttpContext): Observable<EntryDto> {
    return this.insertEntry$Response(params, context).pipe(
      map((r: StrictHttpResponse<EntryDto>): EntryDto => r.body)
    );
  }

}
